/** Saves a Blob as a file through a temporary object URL. */
export const saveBlob = (filename, blob) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
};

/** Saves CSV text as UTF-8 with a BOM, so Excel reads Greek, Latvian or Bulgarian names correctly. */
export const saveCsv = (filename, csv) =>
  saveBlob(filename, new Blob(['﻿', csv], { type: 'text/csv;charset=utf-8' }));
